import { Flame } from 'lucide-react';

interface SpicinessBadgeProps {
  level: number;
  size?: 'sm' | 'md' | 'lg';
}

// 「火熱」等級標示（Kevin 2026-10-19 定案：顯示「火熱 N」，N＝等級數字，唔加「度」唔加「價」）
// 沿用 spiciness_level 欄位：level ≥ 1＝顯示；0／undefined＝唔顯示
const COLORS: string[] = [
  'bg-green-100 text-green-700',    // 1
  'bg-green-100 text-green-700',    // 2
  'bg-lime-100 text-lime-700',      // 3
  'bg-lime-100 text-lime-700',      // 4
  'bg-yellow-100 text-yellow-800',  // 5
  'bg-yellow-100 text-yellow-800',  // 6
  'bg-amber-100 text-amber-700',    // 7
  'bg-orange-100 text-orange-700',  // 8
  'bg-red-100 text-red-700',        // 9
  'bg-red-100 text-red-700',        // 10
];

export default function SpicinessBadge({ level, size = 'md' }: SpicinessBadgeProps) {
  if (!level || level < 1) return null;
  const safeLevel = Math.min(10, Math.max(1, Math.round(level)));
  const label = `火熱 ${safeLevel}`;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs gap-1',
    md: 'px-3 py-1 text-sm gap-1.5',
    lg: 'px-4 py-1.5 text-base gap-2',
  };

  const flameSizes = {
    sm: 12,
    md: 16,
    lg: 20,
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${sizeClasses[size]} ${COLORS[safeLevel - 1]}`}
    >
      <Flame size={flameSizes[size]} className="text-x1493-primary" />
      {label}
    </span>
  );
}
